<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 5 24">
    <defs></defs>
    <g id="Layer_2" data-name="Layer 2">
      <g id="transport">
        <circle class="cls-1" cx="2.5" cy="21.5" r="2" />
        <path
          class="cls-1"
          d="M2.5,16.5.64,1.62A1,1,0,0,1,1.63.5H3.37a1,1,0,0,1,1,1.12Z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {};
</script>

<style scoped>
.cls-1 {
  fill: none;
  stroke: var(--v-secondary-base);
  stroke-linecap: round;
  stroke-linejoin: round;
}
</style>
